module.exports = __webpack_public_path__ + "static/media/portfolio-rn.067a5d98.svg";